<template>
    <CommonBox :title="titles[updateType]" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="150px" :model="initForm" :rules="rules">
            <el-form-item label="Document Type" prop="DocumentType">
                <el-input v-model="initForm.DocumentType"></el-input>
            </el-form-item>
            <el-form-item label="Belong To" prop="Pid">
                <el-select v-model="initForm.Pid" placeholder="Select" size="large">
                    <el-option
                    v-for="item in selectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    />
                </el-select>
            </el-form-item>
        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
        updateType:{},
        initForm:{},
        showSelect: {type: Boolean,default:false},
        selectOptions: {type: Array,default:function () {
            return [];
        }}
    },
    data () {
        return {
            titles:{
                add:"Add DocumentType",
                edit:"Edit DocumentType"
            },
            rules:{
                DocumentType:[{required: true, message: 'Please enter a documentType name', trigger: 'blur'}]
            }};
    },
    created () {},
    methods:{
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let methods = this.updateType === 'add' ? 'post' : 'put';
                let url = this.updateType === 'add' ? 'addDocumentsDocumentType' : 'editDocumentsDocumentType';
                this.$http[methods](url,this.initForm,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                    if(this.showSelect) this.$emit('updateSelection');
                });
            });
        }
    }
};
</script>
